import { motion } from "framer-motion";

export const Section = ({ id, children, className = "", dark = false, ...rest }) => {
  return (
    <section
      id={id}
      className={`${dark ? "bg-graphite text-zinc-100" : "bg-white text-zinc-900"} ${className}`}
      {...rest}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">{children}</div>
    </section>
  );
};

export const SectionHeader = ({ overline, title, description, align = "left" }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.5 }}
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {overline && <p className="overline mb-4">{overline}</p>}
      <h2 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tighter leading-[1.05]">
        {title}
      </h2>
      {description && (
        <p className="mt-5 text-base md:text-lg text-zinc-600 max-w-2xl">{description}</p>
      )}
    </motion.div>
  );
};
